import React, { useEffect, useMemo, useState } from "react"
import ReactSVG from "react-svg"
import ArrowLeft from "../../../images/go_back_icon_white.svg"
import { routerPaths } from "../../../v1/constants/paths"
import { Link, withRouter, Prompt } from "react-router-dom"
import { setLastActiveVehicleId, deleteCart } from "../../../v1/actions/user"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import { connect } from "react-redux"
import { Button, Modal } from "semantic-ui-react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import { ReactComponent as Warning } from "../../../images/warning.svg"
import { isDesktop } from "react-device-detect"
import { isEbay, isEbayCart } from "../../../v1/helpers/affiliationHelpers"
import { CA } from "../../../v1/constants/states"

const STEP_CONFIG = {
  "#/service-request/add-vehicle": {
    step: 3,
    name: "Add Vehicle",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/select-vehicle": {
    step: 2,
    name: "Select Vehicle",
    lastStepRoute: routerPaths.selectVehicle
  },
  "#/service-request/confirm-vehicle": {
    step: 3,
    name: "Confirm Vehicle",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/search-service": {
    step: 3,
    name: "Select services",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/select-service-type": {
    step: 3,
    name: "Select services type",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/select-service": {
    step: 3,
    name: "Select services",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/review-services": {
    step: 4,
    name: "Service summary",
    lastStepRoute: routerPaths.selectService
  },
  "#/service-request/shop-selection": {
    step: 5,
    name: "Select shop",
    lastStepRoute: routerPaths.reviewServices
  },
  "#/service-request/appointment": {
    step: 6,
    name: "Select date & time",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/select-date": {
    step: 6,
    name: "Select date",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/recommended-services": {
    step: 7,
    name: "Recommended Services",
    lastStepRoute: routerPaths.appointment
  },
  "#/service-request/add-payment": {
    step: 7,
    name: "Add payment details",
    lastStepRoute: routerPaths.appointment
  },
  "#/service-request/review-request": {
    step: 8,
    name: "Review service request",
    candianName: "Review & confirm request",
    lastStepRoute: routerPaths.addPayment
  },
  "#/service-request/activate-membership": {
    step: 8,
    name: "Activate membership",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/upsell-membership": {
    step: 8,
    name: "Activate membership",
    lastStepRoute: routerPaths.shopSelection
  }
}

// Step configuration for compare price flow
const STEP_CONFIG_COMPARE_PRICE = {
  "#/service-request/compare-vehicle": {
    step: 1,
    name: "Add vehicle",
    lastStepRoute: routerPaths.compareVehicle
  },
  "#/service-request/select-service": {
    step: 2,
    name: "Select services",
    lastStepRoute: routerPaths.compareVehicle
  },
  "#/service-request/search-service": {
    step: 3,
    name: "Select services",
    lastStepRoute: routerPaths.selectService
  },
  "#/service-request/review-services": {
    step: 3,
    name: "Service summary",
    lastStepRoute: routerPaths.selectService
  },
  "#/service-request/shop-selection": {
    step: 3,
    name: "Select shop",
    lastStepRoute: routerPaths.selectService
  },
  "#/service-request/update-user": {
    step: 4,
    name: "Add contact details",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/add-vehicle": {
    step: 5,
    name: "Add vehicle",
    lastStepRoute: routerPaths.updateUser
  },
  "#/service-request/confirm-vehicle": {
    step: 5,
    name: "Confirm Vehicle",
    lastStepRoute: routerPaths.addVehicle
  },
  "#/service-request/select-vehicle": {
    step: 5,
    name: "Select Vehicle",
    lastStepRoute: routerPaths.selectVehicle
  },
  "#/service-request/review-appointment": {
    step: 6,
    name: "Review appointment request",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/appointment": {
    step: 6,
    name: "Select date & time",
    lastStepRoute: routerPaths.shopSelection
  },
  "#/service-request/add-payment": {
    step: 7,
    name: "Add payment details",
    lastStepRoute: routerPaths.appointment
  },
  "#/service-request/activate-membership": {
    step: 7,
    name: "Activate membership",
    lastStepRoute: routerPaths.addPayment
  },
  "#/service-request/review-request": {
    step: 8,
    name: "Review appointment request",
    lastStepRoute: routerPaths.addPayment
  }
}

const DEFAULT_STEP = {
  step: 1,
  name: "Add contact details",
  lastStepRoute: routerPaths.updateUser
}

const ServiceRequestLayout = ({
  children,
  activeVehicle,
  user,
  history,
  cart,
  activeOrder,
  setLastActiveVehicleId,
  deleteCart,
  vehicles
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const [lastLocation, setLastLocation] = useState(null)
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true"
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const lastActiveVehicleId = localStorage.getItem("lastActiveVehicleId")
  const stepConfig = isComparePriceFlow ? STEP_CONFIG_COMPARE_PRICE : STEP_CONFIG

  const handleFlowCancellation = () => {
    if (isComparePriceFlow) {
      if ((lastActiveVehicleId?.length || 0) > 0) {
        setLastActiveVehicleId(parseInt(lastActiveVehicleId))
      }
      localStorage.removeItem("isComparePriceFlow")
      localStorage.removeItem("lastActiveVehicleId")
    }
  }

  // Memoize step calculation for performance and clarity
  const { step, name, lastStepRoute, candianName } = useMemo(() => {
    const baseHash = window.location.hash.split("?")[0]
    return stepConfig[baseHash] || DEFAULT_STEP
  }, [window.location.hash, stepConfig])

  let isStepValid = false

  if (isComparePriceFlow) {
    isStepValid = !!activeVehicle?.id ? step <= 2 : step <= 1
  } else {
    isStepValid = step <= 2
  }

  // Scroll to top on step change
  useEffect(() => {
    if (typeof window !== "undefined") {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.scrollTo(0, 0) // Fallback for other browsers
    }
  }, [step])

  useEffect(() => {
    const url = window.location.hash
    const validUserData = !!user?.cellPhone && (user?.lastName?.length || 0) > 0

    if (url !== "#/service-request") return

    if (isComparePriceFlow) {
      history.replace(routerPaths.compareVehicle)
      return
    }

    if (!validUserData) {
      history.replace(routerPaths.updateUser)
      return
    }

    if (!activeVehicle?.id) {
      history.replace(routerPaths.selectVehicle)
      return
    }

    if (isOilChangeService) {
      if (user.country === CA) {
        if (vehicles.length === 1) {
          history.replace(routerPaths.selectDate)
          return
        } else {
          history.replace(routerPaths.selectVehicle)
          return
        }
      }
      history.replace(routerPaths.shopSelection)
      return
    }

    if (cart?.order_services?.length > 0) {
      history.replace(routerPaths.reviewServices)
      return
    }

    if (activeOrder && activeOrder.vehicle_id === activeVehicle?.id) {
      history.replace(routerPaths.selectVehicle)
      return
    }

    if (vehicles.length === 1) {
      history.replace(routerPaths.selectServiceType)
      return
    }

    if (vehicles.length > 1) {
      history.replace(routerPaths.selectVehicle)
      return
    }

    if (validUserData) {
      history.replace(routerPaths.selectVehicle)
      return
    } else {
      history.replace(routerPaths.updateUser)
      return
    }
  }, [activeOrder, activeVehicle, history, isComparePriceFlow])

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      history.push(lastLocation.pathname)
    }
  }, [confirmedNavigation, lastLocation, history])

  const hideBackButton = () => {
    return !!(isEbay() && user.total_shop_orders === 0 && isVehicleFlow())
  }
  const hideCancel = () => {
    return !!(isEbay() && user.total_shop_orders === 0)
  }
  const isVehicleFlow = () => {
    return (
      history.location.pathname === routerPaths.selectVehicle ||
      history.location.pathname === routerPaths.confirmVehicle ||
      history.location.pathname === routerPaths.addVehicle ||
      history.location.pathname === routerPaths.appointment
    )
  }
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === "#/service-request") {
        history.push({ pathname: routerPaths.dashboard })
      }
    }
    window.addEventListener("hashchange", handleHashChange)
    return () => {
      window.removeEventListener("hashchange", handleHashChange)
    }
  }, [history])

  useEffect(() => {
    const unblock = history.block((txLocation, action) => {
      if (confirmedNavigation) return true
      if (
        !!cart &&
        cart.cart_type == "walk_in" &&
        !(
          txLocation.pathname.includes("/service-request") ||
          txLocation.pathname.includes("/appointment-confirm")
        )
      ) {
        setLastLocation(txLocation)
        setModalOpen(true)
        return false
      }

      return true
    })

    return () => {
      if (typeof unblock === "function") unblock()
    }
  }, [history, confirmedNavigation])

  return (
    <div className="service-request">
      <Modal open={modalOpen} className="cancel-appointment-modal">
        <Modal.Content>
          <div className="cancel-modal">
            <FontAwesomeIcon
              icon={faClose}
              onClick={() => {
                setModalOpen(false)
                setLastLocation(null)
              }}
              className="close-icon"
            />

            <div className="icon-wrapper">
              <Warning className="warning-icon" />
            </div>

            <p className="title">Are you sure you want to cancel?</p>
            <p className="subtitle">Your changes won't be saved</p>

            <div className="actions">
              <Button
                disabled={loading}
                loading={loading}
                onClick={async () => {
                  if (lastLocation) {
                    setModalOpen(false)
                    setConfirmedNavigation(true)
                    return
                  }
                  if (!!cart?.id) {
                    setLoading(true)
                    const res = await deleteCart(cart.id)
                    trackFirebaseAnalytics({
                      event: gaJSON.flow_cancelled_by_user,
                      params: {
                        currentStep: name,
                        cartType: cart.cart_type || "scheduled"
                      }
                    })
                    setLoading(false)
                    if (!res().result) {
                      setModalOpen(false)
                      return
                    }
                  }
                  setModalOpen(false)
                  handleFlowCancellation()
                  setLastLocation({ pathname: routerPaths.dashboard })
                  setConfirmedNavigation(true)
                }}
                content="Yes, cancel"
                className="btn no"
              />
            </div>
          </div>
        </Modal.Content>
      </Modal>
      <div className="service-request-header">
        <div className="header-content">
          {isStepValid ? (
            <span></span>
          ) : hideBackButton() ? (
            <span></span>
          ) : (
            <div
              onClick={() => {
                trackFirebaseAnalytics({
                  event: gaJSON.EtoB_go_to_earlier_step,
                  params: {
                    currentStep: name,
                    prevStep: lastStepRoute
                  }
                })
                history.goBack()
              }}
              style={{ display: "flex", gap: "5px", alignItems: "center", cursor: "pointer" }}
            >
              <ReactSVG src={ArrowLeft} />
              {isDesktop && <p style={{ margin: 0, fontSize: "14px" }}>Go back</p>}
            </div>
          )}
          <div className="service-request-stepper">
            <p className="bold">{user.country === CA && candianName ? candianName : name}</p>
          </div>
          {hideCancel() ? (
            <span></span>
          ) : (
            <p onClick={() => setModalOpen(true)} style={{ cursor: "pointer" }}>
              Cancel
            </p>
          )}
        </div>
      </div>
      <div className="service-request-content">{children}</div>
    </div>
  )
}

function mapStateToProps(state) {
  const user = state.user || {}
  const activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let activeOrder =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  const cart =
    user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
  return {
    user,
    activeVehicle,
    cart,
    activeOrder,
    vehicles: user.vehicles
  }
}

export default withRouter(
  connect(mapStateToProps, { setLastActiveVehicleId, deleteCart })(ServiceRequestLayout)
)
